import { Card, Tag, Button, Inline, Stack, Text } from 'braid-design-system';

import { getRefineSearchQuery } from 'src/components/Search/utils/utils';
import { useSelector } from 'src/store/react';
import { useRunSearch } from 'src/store/search/useRunSearch';
import { selectSearchQuery } from 'src/store/selectors';

export const NudgeIntent = () => {
  const searchQuery = getRefineSearchQuery(useSelector(selectSearchQuery));
  const runSearch = useRunSearch();

  return (
    <Card>
      <Stack space="small">
        <Text>
          Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quod ipsum
          provident adipisci temporibus commodi cupiditate esse voluptatibus
          velit, unde quisquam, architecto maxime voluptates fugit autem atque
          hic inventore id omnis!
        </Text>
        <Inline space="small">
          <Tag>One</Tag>
          <Tag>One</Tag>
          <Tag>One</Tag>
          <Tag>One</Tag>
        </Inline>
        <Button
          onClick={() => {
            runSearch({
              pathname: searchQuery,
            });
          }}
        >
          SEEK X Jobs
        </Button>
      </Stack>
    </Card>
  );
};
